/* =========================================================
   NEXO THEME — global.js
   ========================================================= */
(function () {
  'use strict';

  const T = window.theme || {};
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = Math.round(Number(cents) || 0);
    format = format || T.moneyFormat || '{{amount}}';
    const re = /\{\{\s*(\w+)\s*\}\}/;
    const num = (n, precision, thousands = ',', decimal = '.') => {
      const fixed = (n / 100).toFixed(precision);
      const [ints, decs] = fixed.split('.');
      return ints.replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (decs ? decimal + decs : '');
    };
    const m = format.match(re);
    if (!m) return format;
    let v;
    switch (m[1]) {
      case 'amount': v = num(cents, 2); break;
      case 'amount_no_decimals': v = num(cents, 0); break;
      case 'amount_with_comma_separator': v = num(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = num(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = num(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': v = num(cents, 0, ' ', ','); break;
      case 'amount_with_space_separator': v = num(cents, 2, ' ', ','); break;
      case 'amount_with_period_and_space_separator': v = num(cents, 2, ' ', '.'); break;
      default: v = num(cents, 2);
    }
    return format.replace(re, v);
  }
  window.NexoFormatMoney = formatMoney;

  const tmp = document.createElement('div');
  const stripHtml = (html) => { tmp.innerHTML = html; return tmp.textContent; };
  const money = (c) => stripHtml(formatMoney(c));

  function toast(msg) {
    const el = $('[data-toast]');
    if (!el) return;
    el.textContent = msg;
    el.hidden = false;
    clearTimeout(el._t);
    el._t = setTimeout(() => { el.hidden = true; }, 2600);
  }

  /* ---------- Drawers ---------- */
  function openDrawer(el) {
    if (!el) return;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
    const focusable = el.querySelector('input[type=search], button, a');
    if (focusable) setTimeout(() => focusable.focus({ preventScroll: true }), 300);
  }
  function closeDrawers() {
    $$('.drawer.is-open').forEach((d) => { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); });
    document.body.classList.remove('no-scroll');
  }
  window.NexoOpenCart = () => {
    const d = document.getElementById('CartDrawer');
    if (d) openDrawer(d); else window.location.href = T.routes.cart;
  };

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open-drawer]');
    if (opener) {
      e.preventDefault();
      closeDrawers();
      openDrawer(document.getElementById(opener.dataset.openDrawer));
      return;
    }
    if (e.target.closest('[data-close-drawer]')) { e.preventDefault(); closeDrawers(); return; }

    const cartTrigger = e.target.closest('[data-cart-trigger]');
    if (cartTrigger && T.cartType === 'drawer' && document.getElementById('CartDrawer')) {
      e.preventDefault();
      window.NexoOpenCart();
      return;
    }

    const modalOpener = e.target.closest('[data-open-modal]');
    if (modalOpener) {
      const m = document.getElementById(modalOpener.dataset.openModal);
      if (m && m.showModal) { e.preventDefault(); m.showModal(); }
      return;
    }
    if (e.target.closest('[data-close-modal]')) { e.target.closest('dialog').close(); return; }
    if (e.target.tagName === 'DIALOG') { e.target.close(); return; }

    const copy = e.target.closest('[data-copy]');
    if (copy) {
      e.preventDefault();
      navigator.clipboard && navigator.clipboard.writeText(copy.dataset.copy).then(() => toast(T.strings.copied));
    }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawers(); });

  /* ---------- Cart ---------- */
  const Cart = {
    sectionIds() {
      const ids = [];
      if (document.getElementById('CartDrawer')) ids.push('cart-drawer');
      $$('[data-main-cart]').forEach((el) => ids.push(el.dataset.sectionId));
      return ids;
    },
    async refresh(open) {
      const ids = this.sectionIds();
      const reqs = [fetch(T.routes.cart + '.js', { headers: { Accept: 'application/json' } }).then((r) => r.json())];
      if (ids.length) reqs.push(fetch(`${window.location.pathname}?sections=${ids.join(',')}`).then((r) => r.json()));
      let [cart, sections] = await Promise.all(reqs);
      if (!this._syncing && await syncExtras(cart)) {
        this._syncing = true;
        try { return await this.refresh(open); } finally { this._syncing = false; }
      }
      if (sections) this.render(sections);
      this.updateCount(cart.item_count);
      document.dispatchEvent(new CustomEvent('nexo:cart-updated', { detail: { cart } }));
      if (open) window.NexoOpenCart();
      return cart;
    },
    render(sections) {
      Object.keys(sections).forEach((id) => {
        const html = sections[id];
        if (!html) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newInner = doc.querySelector('[data-cart-inner]');
        const target = id === 'cart-drawer'
          ? $('#CartDrawer [data-cart-inner]')
          : $(`[data-main-cart][data-section-id="${id}"] [data-cart-inner]`);
        if (newInner && target) target.innerHTML = newInner.innerHTML;
      });
      Timers.cart();
      loadCartRecommendations();
    },
    updateCount(count) {
      $$('[data-cart-count]').forEach((el) => { el.textContent = count; el.hidden = count === 0; });
    },
    async add(items) {
      const res = await fetch(T.routes.cartAdd + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items })
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || T.strings.error);
      return data;
    },
    async change(line, quantity) {
      const res = await fetch(T.routes.cartChange + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity })
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || T.strings.error);
      return data;
    },
    async afterAdd() {
      const P = T.protection;
      if (P && P.default && !store.sget('nexoProtectionOff')) {
        try {
          const c = await (await fetch(T.routes.cart + '.js')).json();
          if (!c.items.some((i) => i.variant_id === P.variant)) await this.add([{ id: P.variant, quantity: 1 }]);
        } catch (e) { /* noop */ }
      }
      if (T.cartType === 'drawer' && document.getElementById('CartDrawer')) {
        await this.refresh(true);
      } else {
        window.location.href = T.routes.cart;
      }
    }
  };
  window.NexoCart = Cart;

  function showCartError(msg) {
    $$('[data-cart-error]').forEach((el) => { el.textContent = msg; el.hidden = false; });
  }

  async function changeLine(line, qty, btn) {
    const wrap = btn && btn.closest('.cart-item');
    if (wrap) wrap.style.opacity = '.5';
    try {
      await Cart.change(Number(line), Math.max(0, Number(qty)));
      await Cart.refresh(false);
    } catch (err) {
      showCartError(err.message);
      if (wrap) wrap.style.opacity = '';
    }
  }

  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-cart-qty]');
    if (b) { e.preventDefault(); changeLine(b.dataset.line, b.dataset.qty, b); }
  });
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-cart-input]');
    if (input) changeLine(input.dataset.line, input.value, input);

    const note = e.target.closest('[data-cart-note]');
    if (note) {
      fetch(T.routes.cartUpdate + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note.value })
      });
    }
    const terms = e.target.closest('[data-terms]');
    if (terms) {
      const scope = terms.closest('[data-cart-inner]') || document;
      $$('[data-checkout]', scope).forEach((b) => { b.disabled = !terms.checked; });
    }
    const upsellVariant = e.target.closest('[data-upsell-variant]');
    if (upsellVariant) {
      const opt = upsellVariant.selectedOptions[0];
      const card = upsellVariant.closest('.upsell-card');
      const priceEl = card && card.querySelector('[data-price-regular]');
      if (priceEl && opt.dataset.price) priceEl.textContent = money(opt.dataset.price);
    }
  });

  /* Any form with data-ajax-add (quick add, upsells) */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-ajax-add]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[type=submit]');
    const fd = new FormData(form);
    if (btn) btn.classList.add('is-loading');
    try {
      await Cart.add([{ id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1) }]);
      await Cart.afterAdd();
    } catch (err) {
      toast(err.message);
    } finally {
      if (btn) btn.classList.remove('is-loading');
    }
  });

  /* Cart drawer recommendations (when no upsell products chosen) */
  async function loadCartRecommendations() {
    const box = $('[data-cart-recs]');
    if (!box || box.dataset.loaded === box.dataset.productId) return;
    box.dataset.loaded = box.dataset.productId;
    try {
      const url = `${T.routes.root}recommendations/products?section_id=cart-upsell-recs&product_id=${box.dataset.productId}&limit=${Number(box.dataset.limit) + 4}`;
      const html = await (await fetch(url)).text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const inCart = (box.dataset.exclude || '').split(',');
      const cards = $$('[data-upsell-product]', doc).filter((c) => !inCart.includes(c.dataset.upsellProduct)).slice(0, Number(box.dataset.limit));
      const list = box.querySelector('[data-cart-recs-list]');
      if (cards.length && list) {
        list.innerHTML = '';
        cards.forEach((c) => list.appendChild(c));
        box.hidden = false;
      }
    } catch (err) { /* silencioso */ }
  }

  /* ---------- Timers (cart reservation + countdowns) ---------- */
  const pad = (n) => String(Math.max(0, n)).padStart(2, '0');
  const store = {
    get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { localStorage.setItem(k, v); } catch (e) { /* noop */ } },
    sget(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
    sset(k, v) { try { sessionStorage.setItem(k, v); } catch (e) { /* noop */ } }
  };

  const Timers = {
    cart() {
      const el = $('[data-cart-timer]');
      if (!el) return;
      const mins = Number(el.dataset.minutes) || 10;
      let end = Number(store.sget('nexoCartTimer'));
      if (!end || end < Date.now()) { end = Date.now() + mins * 60000; store.sset('nexoCartTimer', end); }
      this.cartEnd = end;
      this.tick();
    },
    countdownEnd(el) {
      const mode = el.dataset.mode;
      const now = new Date();
      if (mode === 'fixed') {
        const raw = (el.dataset.end || '').trim().replace(' ', 'T');
        const d = new Date(raw);
        return isNaN(d) ? null : d.getTime();
      }
      if (mode === 'evergreen') {
        const key = 'nexoCd_' + (el.dataset.uid || 'x');
        let end = Number(store.get(key));
        const span = (Number(el.dataset.minutes) || 15) * 60000;
        if (!end || end < Date.now()) { end = Date.now() + span; store.set(key, end); }
        return end;
      }
      const midnight = new Date(now);
      midnight.setHours(24, 0, 0, 0);
      return midnight.getTime();
    },
    tick() {
      const now = Date.now();
      if (this.cartEnd) {
        let left = Math.round((this.cartEnd - now) / 1000);
        if (left <= 0) { this.cartEnd = 0; this.cart(); return; }
        $$('[data-cart-timer-value]').forEach((el) => { el.textContent = `${pad(Math.floor(left / 60))}:${pad(left % 60)}`; });
      }
      $$('[data-countdown]').forEach((el) => {
        if (!el._end) el._end = this.countdownEnd(el);
        if (!el._end) return;
        let left = Math.floor((el._end - now) / 1000);
        if (left <= 0) {
          if (el.hasAttribute('data-hide-expired')) { (el.closest('[data-countdown-wrap]') || el).hidden = true; return; }
          if (el.dataset.mode !== 'fixed') { el._end = null; return; }
          left = 0;
        }
        const d = Math.floor(left / 86400);
        const h = Math.floor((left % 86400) / 3600);
        const m = Math.floor((left % 3600) / 60);
        const s = left % 60;
        const set = (k, v) => { const n = el.querySelector(`[data-cd="${k}"]`); if (n) n.textContent = pad(v); };
        set('d', d); set('h', h); set('m', m); set('s', s);
        const dw = el.querySelector('[data-cd-days-wrap]');
        if (dw) dw.hidden = d === 0;
      });
    },
    start() {
      this.cart();
      this.tick();
      setInterval(() => this.tick(), 1000);
    }
  };

  /* ---------- Rotators / announcement ---------- */
  function initRotators(ctx = document) {
    $$('[data-rotator]', ctx).forEach((r) => {
      if (r._init) return;
      r._init = true;
      const items = $$('.announcement__item', r);
      if (items.length < 2) return;
      let i = 0;
      setInterval(() => {
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, (Number(r.dataset.interval) || 4) * 1000);
    });
  }

  /* ---------- Sliders with arrows / slideshow ---------- */
  function initSliders(ctx = document) {
    $$('[data-slider-prev], [data-slider-next]', ctx).forEach((btn) => {
      if (btn._init) return;
      btn._init = true;
      btn.addEventListener('click', () => {
        const track = document.getElementById(btn.dataset.target);
        if (!track) return;
        const dir = btn.hasAttribute('data-slider-next') ? 1 : -1;
        const item = track.firstElementChild;
        const step = item ? item.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0) : track.clientWidth;
        track.scrollBy({ left: dir * step, behavior: 'smooth' });
      });
    });
    $$('[data-slideshow]', ctx).forEach((ss) => {
      if (ss._init) return;
      ss._init = true;
      const track = $('.slideshow__track', ss);
      const dots = $$('.slideshow__dot', ss);
      const slides = $$('.slideshow__slide', ss);
      if (slides.length < 2) return;
      let idx = 0;
      const go = (i) => { idx = (i + slides.length) % slides.length; track.scrollTo({ left: slides[idx].offsetLeft, behavior: 'smooth' }); };
      dots.forEach((d, i) => d.addEventListener('click', () => go(i)));
      track.addEventListener('scroll', () => {
        const i = Math.round(track.scrollLeft / track.clientWidth);
        dots.forEach((d, j) => d.classList.toggle('is-active', i === j));
        idx = i;
      }, { passive: true });
      const speed = Number(ss.dataset.autoplay);
      if (speed > 0) {
        let paused = false;
        ss.addEventListener('mouseenter', () => { paused = true; });
        ss.addEventListener('mouseleave', () => { paused = false; });
        setInterval(() => { if (!paused && !document.hidden) go(idx + 1); }, speed * 1000);
      }
    });
  }

  /* ---------- Delivery dates ---------- */
  function addBusinessDays(date, days, skipWeekends) {
    const d = new Date(date);
    let added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      const wd = d.getDay();
      if (skipWeekends && (wd === 0 || wd === 6)) continue;
      added++;
    }
    return d;
  }
  function initDelivery(ctx = document) {
    $$('[data-delivery]', ctx).forEach((el) => {
      const skip = el.dataset.skipWeekends === 'true';
      const fmt = (d) => d.toLocaleDateString(T.locale || undefined, { weekday: 'short', day: 'numeric', month: 'short' });
      const now = new Date();
      const min = addBusinessDays(now, Number(el.dataset.min) || 0, skip);
      const max = addBusinessDays(now, Number(el.dataset.max) || 0, skip);
      const ship = addBusinessDays(now, Number(el.dataset.ship) || 1, skip);
      $$('[data-delivery-min]', el).forEach((n) => { n.textContent = fmt(min); });
      $$('[data-delivery-max]', el).forEach((n) => { n.textContent = fmt(max); });
      $$('[data-delivery-ship]', el).forEach((n) => { n.textContent = fmt(ship); });
      $$('[data-delivery-today]', el).forEach((n) => { n.textContent = fmt(now); });
    });
  }

  /* ---------- Popup ---------- */
  function initPopups(ctx = document) {
    $$('[data-popup]', ctx).forEach((dlg) => {
      if (dlg._init || !dlg.showModal) return;
      dlg._init = true;
      if (window.Shopify && window.Shopify.designMode && dlg.dataset.preview !== 'true') return;
      const key = 'nexoPopup_' + dlg.dataset.popup;
      const days = Number(dlg.dataset.days) || 0;
      const last = Number(store.get(key));
      if (last && (Date.now() - last) < days * 86400000) return;
      const show = () => { if (!dlg.open) { dlg.showModal(); store.set(key, Date.now()); } };
      if (dlg.dataset.trigger === 'exit') {
        document.addEventListener('mouseout', function h(e) { if (!e.relatedTarget && e.clientY < 10) { show(); document.removeEventListener('mouseout', h); } });
        setTimeout(show, 30000);
      } else {
        setTimeout(show, (Number(dlg.dataset.delay) || 5) * 1000);
      }
    });
  }

  /* ---------- Videos (click to play) ---------- */
  document.addEventListener('click', (e) => {
    const poster = e.target.closest('[data-video-poster]');
    if (!poster) return;
    const tpl = poster.parentElement.querySelector('template');
    if (tpl) { poster.parentElement.appendChild(tpl.content.cloneNode(true)); poster.remove(); const v = poster.parentElement && poster.parentElement.querySelector('video'); if (v) v.play(); }
  });

  /* ---------- Recommendations (related products) ---------- */
  function initRecommendations(ctx = document) {
    $$('[data-recommendations]', ctx).forEach(async (el) => {
      if (el._init || !el.dataset.url) return;
      el._init = true;
      try {
        const html = await (await fetch(el.dataset.url)).text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim()) { el.innerHTML = fresh.innerHTML; initSliders(el); }
      } catch (err) { /* noop */ }
    });
  }

  /* ---------- Collection filters ---------- */
  document.addEventListener('change', (e) => {
    const form = e.target.closest('[data-filter-form]');
    if (form && window.matchMedia('(min-width: 990px)').matches && e.target.type !== 'number') form.submit();
    const sort = e.target.closest('[data-sort]');
    if (sort) {
      const f = document.getElementById('FilterForm');
      if (f) { f.submit(); } else {
        const u = new URL(window.location.href);
        u.searchParams.set('sort_by', sort.value);
        u.searchParams.delete('page');
        window.location.href = u.toString();
      }
    }
  });

  /* ---------- Product section ---------- */
  class ProductSection {
    constructor(root) {
      this.root = root;
      const json = $('[data-product-json]', root);
      if (!json) return;
      this.variants = JSON.parse(json.textContent);
      this.formId = root.dataset.formId;
      this.form = document.getElementById(this.formId);
      this.idInput = this.form ? $('[data-variant-id]', this.form) : null;
      this.variant = this.variants.find((v) => String(v.id) === String(root.dataset.variantId)) || this.variants[0];

      root.addEventListener('change', (e) => this.onChange(e));
      root.addEventListener('click', (e) => this.onClick(e));
      if (this.form) this.form.addEventListener('submit', (e) => this.onSubmit(e));

      this.initGallery();
      this.initSticky();
      this.updateAvailability();
      this.updateInventory();
      this.updateBreaks();
      this.updateBundles();
      const sel = $('[data-break-input]:checked', root);
      if (sel) this.selectBreak(sel);
    }

    selectedOptions() {
      const out = [];
      $$('[data-option-index]', this.root).forEach((fs) => {
        const i = Number(fs.dataset.optionIndex);
        const checked = $('[data-option-input]:checked', fs);
        const select = $('select[data-option-input]', fs);
        out[i] = checked ? checked.value : select ? select.value : null;
      });
      return out;
    }

    onChange(e) {
      const t = e.target;
      if (t.matches('[data-option-input]')) {
        const opts = this.selectedOptions();
        const idx = Number(t.dataset.index);
        const label = $(`[data-option-selected="${idx}"]`, this.root);
        if (label) label.textContent = t.value;
        let v = this.variants.find((x) => x.options.every((o, i) => opts[i] == null || o === opts[i]));
        this.setVariant(v || null);
      }
      if (t.matches('[data-break-input]')) this.selectBreak(t);
      if (t.matches('[data-qty-input]')) {
        $$('[data-break]', this.root).forEach((b) => { const r = $('[data-break-input]', b); const on = Number(b.dataset.qty) === Number(t.value); b.classList.toggle('is-selected', on); if (r) r.checked = on; });
      }
      if (t.matches('[data-addon-variant]')) {
        const box = t.closest('[data-addon]');
        const input = box && $('[data-addon-input]', box);
        if (input) input.value = t.value;
        const opt = t.selectedOptions[0];
        const p = box && $('[data-addon-price]', box);
        if (p && opt.dataset.price) p.textContent = money(opt.dataset.price);
      }
      if (t.matches('[data-bundle-input], [data-bundle-variant]')) {
        if (t.matches('[data-bundle-variant]')) {
          const item = t.closest('[data-bundle-item]');
          const opt = t.selectedOptions[0];
          item.dataset.variantId = t.value;
          item.dataset.price = opt.dataset.price;
          item.dataset.compare = opt.dataset.compare;
        }
        this.updateBundles();
      }
      if (t.matches('[data-sticky-variant]')) {
        const v = this.variants.find((x) => String(x.id) === t.value);
        if (v) this.syncOptionsToVariant(v);
      }
    }

    onClick(e) {
      const q = e.target.closest('[data-qty-btn]');
      if (q) {
        const input = $('[data-qty-input]', this.root);
        if (!input) return;
        const step = q.dataset.qtyBtn === 'plus' ? 1 : -1;
        input.value = Math.max(1, (Number(input.value) || 1) + step);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      const bundleAdd = e.target.closest('[data-bundle-add]');
      if (bundleAdd) this.addBundle(bundleAdd);
      const stickyAdd = e.target.closest('[data-sticky-add]');
      if (stickyAdd && this.form) {
        if (this.form.requestSubmit) this.form.requestSubmit(); else this.form.dispatchEvent(new Event('submit', { cancelable: true }));
      }
    }

    syncOptionsToVariant(v) {
      v.options.forEach((val, i) => {
        const fs = $(`[data-option-index="${i}"]`, this.root);
        if (!fs) return;
        $$('[data-option-input]', fs).forEach((inp) => {
          if (inp.tagName === 'SELECT') inp.value = val; else inp.checked = inp.value === val;
        });
        const label = $(`[data-option-selected="${i}"]`, this.root);
        if (label) label.textContent = val;
      });
      this.setVariant(v);
    }

    setVariant(v) {
      this.variant = v;
      const btns = $$('[data-add-button], [data-sticky-add]', this.root);
      if (!v) {
        btns.forEach((b) => { b.disabled = true; const s = $('[data-add-text]', b) || b; s.textContent = T.strings.unavailable; });
        this.updateAvailability();
        return;
      }
      if (this.idInput) this.idInput.value = v.id;
      this.root.dataset.variantId = v.id;

      // Prices
      $$('[data-price]', this.root).forEach((p) => {
        if (p.closest('[data-bundle], [data-addon], .upsell-card')) return;
        const reg = $('[data-price-regular]', p);
        const cmp = $('[data-price-compare]', p);
        const badge = $('[data-price-badge]', p);
        const onSale = v.compare_at_price > v.price;
        if (reg) reg.textContent = money(v.price);
        p.classList.toggle('price--sale', onSale);
        if (cmp) { cmp.hidden = !onSale; cmp.textContent = onSale ? money(v.compare_at_price) : ''; }
        if (badge) {
          badge.hidden = !onSale;
          if (onSale) {
            const type = p.dataset.badgeType;
            if (type === 'amount') badge.textContent = (T.strings.save || '').replace('[amount]', money(v.compare_at_price - v.price));
            else if (type === 'text') badge.textContent = p.dataset.badgeText || badge.textContent;
            else badge.textContent = '-' + Math.floor(((v.compare_at_price - v.price) * 100) / v.compare_at_price) + '%';
          }
        }
      });

      // Buttons
      btns.forEach((b) => {
        b.disabled = !v.available;
        const s = $('[data-add-text]', b) || b;
        s.textContent = v.available ? (b.dataset.label || T.strings.addToCart) : T.strings.soldOut;
      });

      // SKU
      $$('[data-sku]', this.root).forEach((el) => { el.textContent = v.sku || ''; el.parentElement.hidden = !v.sku; });

      // URL
      if (this.root.dataset.updateUrl === 'true') {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }

      // Media
      if (v.media) this.goToMedia(v.media);

      // Sticky
      const sp = $('[data-sticky-price]', this.root);
      if (sp) sp.textContent = money(v.price);
      const sc = $('[data-sticky-compare]', this.root);
      if (sc) { sc.hidden = !(v.compare_at_price > v.price); sc.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : ''; }
      const ss = $('[data-sticky-variant]', this.root);
      if (ss && ss.value !== String(v.id)) ss.value = v.id;
      const si = $('[data-sticky-img]', this.root);
      if (si && v.image) si.src = v.image;

      this.updateAvailability();
      this.updateInventory();
      this.updateBreaks();
      this.updateBundles();
      document.dispatchEvent(new CustomEvent('nexo:variant-change', { detail: { variant: v, section: this.root } }));
    }

    updateAvailability() {
      const opts = this.selectedOptions();
      $$('[data-option-index]', this.root).forEach((fs) => {
        const i = Number(fs.dataset.optionIndex);
        $$('[data-option-input]', fs).forEach((inp) => {
          const values = inp.tagName === 'SELECT' ? Array.from(inp.options) : [inp];
          values.forEach((node) => {
            const val = node.value;
            const ok = this.variants.some((v) => v.available && v.options[i] === val && v.options.every((o, j) => j === i || opts[j] == null || o === opts[j]));
            if (inp.tagName === 'SELECT') {
              node.textContent = node.dataset.label + (ok ? '' : ` — ${T.strings.soldOut}`);
            } else {
              const lbl = inp.nextElementSibling;
              if (lbl) lbl.classList.toggle('is-unavailable', !ok);
            }
          });
        });
      });
    }

    updateInventory() {
      const v = this.variant;
      $$('[data-inventory]', this.root).forEach((el) => {
        const textEl = $('[data-inventory-text]', el);
        const bar = $('[data-inventory-bar]', el);
        const threshold = Number(el.dataset.threshold) || 10;
        el.classList.remove('is-low', 'is-out');
        el.hidden = false;
        if (!v || !v.available) {
          el.classList.add('is-out');
          textEl.textContent = el.dataset.out;
          if (bar) bar.parentElement.hidden = true;
          return;
        }
        if (v.tracked && v.inventory > 0 && v.inventory <= threshold) {
          el.classList.add('is-low');
          textEl.innerHTML = el.dataset.low.replace('[count]', `<strong>${v.inventory}</strong>`);
          if (bar) { bar.parentElement.hidden = false; bar.style.width = Math.max(8, Math.min(100, (v.inventory / threshold) * 100)) + '%'; }
        } else {
          if (!el.dataset.in) { el.hidden = true; return; }
          textEl.textContent = el.dataset.in;
          if (bar) bar.parentElement.hidden = true;
        }
      });
    }

    updateBreaks() {
      const v = this.variant;
      if (!v) return;
      const base = v.price;
      const baseCompare = Math.max(v.compare_at_price || 0, v.price);
      $$('[data-break]', this.root).forEach((b) => {
        const qty = Number(b.dataset.qty);
        const disc = Number(b.dataset.discount) || 0;
        const total = Math.floor((base * qty * (100 - disc)) / 100);
        const compare = baseCompare * qty;
        const set = (sel, val) => $$(sel, b).forEach((n) => { n.textContent = val; });
        set('[data-break-price]', money(total));
        set('[data-break-unit]', money(Math.floor(total / qty)));
        set('[data-break-saving]', money(compare - total));
        $$('[data-break-compare]', b).forEach((n) => { n.textContent = money(compare); n.hidden = compare <= total; });
      });
    }

    selectBreak(input) {
      $$('[data-break]', this.root).forEach((b) => b.classList.toggle('is-selected', b.contains(input)));
      const qty = Number(input.value) || 1;
      const qi = $('[data-qty-input]', this.root);
      if (qi) qi.value = qty;
      this.breakQty = qty;
    }

    updateBundles() {
      $$('[data-bundle]', this.root).forEach((bundle) => {
        const main = $('[data-bundle-main]', bundle);
        if (main && this.variant) {
          main.dataset.price = this.variant.price;
          main.dataset.compare = Math.max(this.variant.compare_at_price || 0, this.variant.price);
          main.dataset.variantId = this.variant.id;
          const mp = $('[data-bundle-main-price]', main);
          if (mp) mp.textContent = money(this.variant.price);
        }
        const disc = Number(bundle.dataset.discount) || 0;
        let total = 0; let compare = 0; let count = 0;
        $$('[data-bundle-item]', bundle).forEach((item) => {
          const cb = $('[data-bundle-input]', item);
          if (cb && !cb.checked) return;
          total += Number(item.dataset.price) || 0;
          compare += Number(item.dataset.compare) || Number(item.dataset.price) || 0;
          count++;
        });
        const final = Math.floor((total * (100 - (count > 1 ? disc : 0))) / 100);
        const pe = $('[data-bundle-price]', bundle);
        const ce = $('[data-bundle-compare]', bundle);
        if (pe) pe.textContent = money(final);
        if (ce) { ce.textContent = money(compare); ce.hidden = compare <= final; }
      });
    }

    async addBundle(btn) {
      const bundle = btn.closest('[data-bundle]');
      const items = [];
      $$('[data-bundle-item]', bundle).forEach((item) => {
        const cb = $('[data-bundle-input]', item);
        if (cb && !cb.checked) return;
        if (item.dataset.variantId) items.push({ id: Number(item.dataset.variantId), quantity: 1, properties: bundle.dataset.property ? { _bundle: bundle.dataset.property } : undefined });
      });
      if (!items.length) return;
      btn.classList.add('is-loading');
      try { await Cart.add(items); await Cart.afterAdd(); } catch (err) { toast(err.message); } finally { btn.classList.remove('is-loading'); }
    }

    async onSubmit(e) {
      e.preventDefault();
      if (!this.variant || !this.variant.available) return;
      const btn = $('[data-add-button]', this.form);
      const err = $('[data-form-error]', this.form);
      if (err) err.hidden = true;

      const fd = new FormData(this.form);
      const qtyInput = $('[data-qty-input]', this.root);
      let qty = qtyInput ? Number(qtyInput.value) : (this.breakQty || 1);
      if (!qty || qty < 1) qty = 1;

      const properties = {};
      for (const [k, val] of fd.entries()) {
        const m = k.match(/^properties\[(.+)\]$/);
        if (m && val !== '') properties[m[1]] = val;
      }
      const items = [{ id: Number(this.variant.id), quantity: qty, properties }];
      $$('[data-addon-input]:checked', this.root).forEach((a) => {
        items.push({ id: Number(a.value), quantity: a.dataset.matchQty === 'true' ? qty : 1 });
      });

      if (btn) btn.classList.add('is-loading');
      try {
        await Cart.add(items);
        await Cart.afterAdd();
      } catch (ex) {
        if (err) { err.textContent = ex.message; err.hidden = false; } else toast(ex.message);
      } finally {
        if (btn) btn.classList.remove('is-loading');
      }
    }

    /* Gallery */
    initGallery() {
      const g = $('[data-gallery]', this.root);
      if (!g) return;
      this.track = $('[data-gallery-track]', g);
      const slides = $$('.gallery__slide', this.track);
      const thumbs = $$('[data-thumb]', g);
      const counter = $('[data-gallery-counter]', g);
      thumbs.forEach((t) => t.addEventListener('click', () => this.goToMedia(t.dataset.thumb)));
      $$('[data-gallery-arrow]', g).forEach((a) => a.addEventListener('click', () => {
        const dir = a.dataset.galleryArrow === 'next' ? 1 : -1;
        const i = Math.round(this.track.scrollLeft / this.track.clientWidth);
        const next = slides[(i + dir + slides.length) % slides.length];
        if (next) this.track.scrollTo({ left: next.offsetLeft, behavior: 'smooth' });
      }));
      if ('IntersectionObserver' in window && slides.length > 1) {
        const io = new IntersectionObserver((entries) => {
          entries.forEach((en) => {
            if (en.isIntersecting && en.intersectionRatio > .6) {
              const id = en.target.dataset.mediaId;
              thumbs.forEach((t) => t.classList.toggle('is-active', t.dataset.thumb === id));
              const active = thumbs.find((t) => t.dataset.thumb === id);
              if (active && active.parentElement) {
                const p = active.parentElement;
                p.scrollTo({ left: active.offsetLeft - p.clientWidth / 2 + active.clientWidth / 2, top: active.offsetTop - p.clientHeight / 2, behavior: 'smooth' });
              }
              if (counter) counter.textContent = `${slides.indexOf(en.target) + 1} / ${slides.length}`;
            }
          });
        }, { root: this.track, threshold: [.6] });
        slides.forEach((s) => io.observe(s));
      }
      const start = this.variant && this.variant.media;
      if (start) requestAnimationFrame(() => this.goToMedia(start, true));
    }

    goToMedia(id, instant) {
      if (!this.track) return;
      const slide = $(`.gallery__slide[data-media-id="${id}"]`, this.track);
      if (!slide) return;
      const style = getComputedStyle(this.track);
      if (style.display === 'grid' || style.flexDirection === 'column') {
        if (!instant) {
          // Grid / stack: lleva la imagen de la variante a la primera posición
          this.track.prepend(slide);
        }
        return;
      }
      this.track.scrollTo({ left: slide.offsetLeft, behavior: instant ? 'auto' : 'smooth' });
    }

    /* Sticky add to cart */
    initSticky() {
      const bar = $('[data-sticky-atc]', this.root);
      const target = this.form ? $('[data-add-button]', this.form) : null;
      if (!bar || !target || !('IntersectionObserver' in window)) return;
      const io = new IntersectionObserver(([en]) => {
        const passed = !en.isIntersecting && en.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', passed);
      });
      io.observe(target);
    }
  }

  function initProducts(ctx = document) {
    $$('[data-product-section]', ctx).forEach((el) => {
      if (el._product) return;
      el._product = new ProductSection(el);
    });
  }


  /* ---------- Free gift / protection sync ---------- */
  async function syncExtras(cart) {
    let changed = false;
    const G = T.freeGift;
    if (G && G.variant) {
      const giftLines = cart.items.map((it, i) => ({ it, line: i + 1 })).filter((x) => x.it.variant_id === G.variant && x.it.properties && x.it.properties._gift);
      const others = cart.items.filter((it) => !(it.variant_id === G.variant && it.properties && it.properties._gift) && !(T.protection && it.variant_id === T.protection.variant));
      const subtotal = others.reduce((a, it) => a + it.final_line_price, 0);
      const qualifies = others.length > 0 && subtotal >= G.threshold;
      if (qualifies && giftLines.length === 0) {
        try { await Cart.add([{ id: G.variant, quantity: 1, properties: { _gift: 'true' } }]); changed = true; } catch (e) { /* noop */ }
      } else if (!qualifies && giftLines.length) {
        await Cart.change(giftLines[0].line, 0); changed = true;
      } else if (giftLines.length && giftLines[0].it.quantity > 1) {
        await Cart.change(giftLines[0].line, 1); changed = true;
      }
    }
    const P = T.protection;
    if (P && P.variant) {
      const onlyProtection = cart.items.length > 0 && cart.items.every((it) => it.variant_id === P.variant || (it.properties && it.properties._gift));
      const pl = cart.items.findIndex((it) => it.variant_id === P.variant);
      if (onlyProtection && pl > -1) { await Cart.change(pl + 1, 0); changed = true; }
      else if (pl > -1 && cart.items[pl].quantity > 1) { await Cart.change(pl + 1, 1); changed = true; }
    }
    return changed;
  }

  document.addEventListener('change', async (e) => {
    const t = e.target.closest('[data-protection-toggle]');
    if (!t) return;
    const id = Number(t.dataset.variant);
    t.disabled = true;
    try {
      if (t.checked) {
        store.sset('nexoProtectionOff', '');
        await Cart.add([{ id, quantity: 1 }]);
      } else {
        store.sset('nexoProtectionOff', '1');
        const c = await (await fetch(T.routes.cart + '.js')).json();
        const idx = c.items.findIndex((it) => it.variant_id === id);
        if (idx > -1) await Cart.change(idx + 1, 0);
      }
      await Cart.refresh(false);
    } catch (err) { toast(err.message); t.disabled = false; }
  });

  /* ---------- Discount codes ---------- */
  async function updateDiscount(codes) {
    const res = await fetch(T.routes.cartUpdate + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: codes.join(',') })
    });
    return res.json();
  }
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-discount-form]');
    if (!form) return;
    e.preventDefault();
    const input = form.querySelector('input');
    const code = input.value.trim();
    if (!code) return;
    const btn = form.querySelector('button');
    btn.classList.add('is-loading');
    try {
      const current = await (await fetch(T.routes.cart + '.js')).json();
      const existing = (current.discount_codes || []).map((d) => d.code);
      const cart = await updateDiscount(existing.concat(code));
      const applied = (cart.discount_codes || []).find((d) => d.code.toLowerCase() === code.toLowerCase());
      await Cart.refresh(false);
      if (!applied || !applied.applicable) {
        $$('[data-discount-error]').forEach((el) => { el.textContent = T.strings.discountInvalid; el.hidden = false; });
      }
    } catch (err) { toast(T.strings.error); } finally { btn.classList.remove('is-loading'); }
  });
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-discount-remove]');
    if (!b) return;
    e.preventDefault();
    const current = await (await fetch(T.routes.cart + '.js')).json();
    const rest = (current.discount_codes || []).map((d) => d.code).filter((c) => c !== b.dataset.discountRemove);
    await updateDiscount(rest);
    await Cart.refresh(false);
  });

  /* ---------- Reveal on scroll ---------- */
  function initReveal(ctx = document) {
    if (!document.body.classList.contains('has-reveal')) return;
    const els = $$('.shopify-section .section:not(.is-revealed)', ctx);
    if (!('IntersectionObserver' in window) || (window.Shopify && window.Shopify.designMode)) { els.forEach((el) => el.classList.add('is-revealed')); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-revealed'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach((el) => {
      if (el.getBoundingClientRect().top < window.innerHeight) el.classList.add('is-revealed'); else io.observe(el);
    });
  }

  /* ---------- Smart header / sticky CTA / parallax (scroll) ---------- */
  let lastY = window.scrollY;
  let ticking = false;
  function onScroll() {
    const y = window.scrollY;
    const smart = $('.header--smart');
    if (smart) {
      const wrap = smart.closest('.shopify-section');
      if (wrap) wrap.classList.toggle('header-hidden', y > lastY && y > 200 && !document.body.classList.contains('no-scroll'));
    }
    $$('[data-sticky-cta]').forEach((el) => el.classList.toggle('is-visible', y > (Number(el.dataset.offset) || 0)));
    $$('[data-parallax]').forEach((el) => {
      const r = el.getBoundingClientRect();
      if (r.bottom < 0 || r.top > window.innerHeight) return;
      const progress = (r.top + r.height / 2 - window.innerHeight / 2) / window.innerHeight;
      el.style.setProperty('--py', `${(progress * -12).toFixed(2)}%`);
    });
    lastY = y;
    ticking = false;
  }
  window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });

  /* ---------- Gallery zoom & lightbox ---------- */
  let lbImages = []; let lbIndex = 0;
  function openLightbox(images, index) {
    const dlg = document.getElementById('Lightbox');
    if (!dlg || !dlg.showModal) return;
    lbImages = images; lbIndex = index;
    $('[data-lightbox-img]', dlg).src = lbImages[lbIndex];
    $$('[data-lightbox-nav]', dlg).forEach((b) => { b.hidden = lbImages.length < 2; });
    dlg.showModal();
  }
  document.addEventListener('click', (e) => {
    const nav = e.target.closest('[data-lightbox-nav]');
    if (nav) {
      lbIndex = (lbIndex + Number(nav.dataset.lightboxNav) + lbImages.length) % lbImages.length;
      $('[data-lightbox-img]').src = lbImages[lbIndex];
      return;
    }
    const slide = e.target.closest('.gallery__slide[data-zoom-src]');
    if (!slide) return;
    const g = slide.closest('[data-gallery]');
    if (!g || g.dataset.zoom === 'none') return;
    const all = $$('.gallery__slide[data-zoom-src]', g);
    openLightbox(all.map((s) => s.dataset.zoomSrc), all.indexOf(slide));
  });
  document.addEventListener('mousemove', (e) => {
    const slide = e.target.closest('.gallery--hover-zoom .gallery__slide[data-zoom-src]');
    $$('.gallery__slide.is-zooming').forEach((s) => { if (s !== slide) s.classList.remove('is-zooming'); });
    if (!slide) return;
    const r = slide.getBoundingClientRect();
    slide.style.setProperty('--zx', `${((e.clientX - r.left) / r.width) * 100}%`);
    slide.style.setProperty('--zy', `${((e.clientY - r.top) / r.height) * 100}%`);
    slide.classList.add('is-zooming');
  });

  /* ---------- Hotspots, tabs, UGC sound ---------- */
  document.addEventListener('click', (e) => {
    const dot = e.target.closest('[data-hotspot]');
    if (dot) {
      const h = dot.closest('.hotspot');
      $$('.hotspot.is-open').forEach((x) => { if (x !== h) x.classList.remove('is-open'); });
      h.classList.toggle('is-open');
      return;
    }
    if (!e.target.closest('.hotspot')) $$('.hotspot.is-open').forEach((x) => x.classList.remove('is-open'));

    const tab = e.target.closest('[data-tab]');
    if (tab) {
      const root = tab.closest('[data-tabs]');
      $$('[data-tab]', root).forEach((b) => b.classList.toggle('is-active', b === tab));
      $$('[data-tab-panel]', root).forEach((p) => { p.hidden = p.dataset.tabPanel !== tab.dataset.tab; });
      return;
    }
    const snd = e.target.closest('[data-ugc-sound]');
    if (snd) {
      const v = snd.parentElement.querySelector('video');
      if (v) { v.muted = !v.muted; snd.textContent = v.muted ? '🔇' : '🔊'; if (!v.muted) v.play(); }
    }
  });

  /* ---------- Init ---------- */
  function initAll(ctx = document) {
    initRotators(ctx);
    initSliders(ctx);
    initDelivery(ctx);
    initPopups(ctx);
    initRecommendations(ctx);
    initProducts(ctx);
    initReveal(ctx);
  }

  document.addEventListener('DOMContentLoaded', () => {
    initAll();
    Timers.start();
    loadCartRecommendations();
    onScroll();
    if (T.freeGift || T.protection) fetch(T.routes.cart + '.js').then((r) => r.json()).then(async (c) => { if (await syncExtras(c)) Cart.refresh(false); }).catch(() => {});
  });

  // Editor de temas
  document.addEventListener('shopify:section:load', (e) => { initAll(e.target); Timers.cart(); });
  document.addEventListener('shopify:block:select', (e) => {
    const slide = e.target.closest('.slideshow__slide');
    if (slide) slide.parentElement.scrollTo({ left: slide.offsetLeft });
    const popup = e.target.closest('dialog');
    if (popup && !popup.open && popup.showModal) popup.showModal();
  });
  document.addEventListener('shopify:section:select', (e) => {
    const popup = e.target.querySelector('dialog[data-popup]');
    if (popup && !popup.open && popup.showModal) popup.showModal();
  });
  document.addEventListener('shopify:section:deselect', (e) => {
    const popup = e.target.querySelector('dialog[data-popup]');
    if (popup && popup.open) popup.close();
  });
})();
